<template>
    <el-form :model="invoiceVoucher" ref="ruleForm" :rules="rules">
        <div class="simple-form flex col-2">
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">开票方集团名称</label>
                </div>
                <div class="form-value">
                    <span>{{ invoiceVoucher.issuerRealName || '' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">开票方公司名称</label>
                </div>
                <div class="form-value">
                    <span>{{ invoiceVoucher.issuerRealComName || '' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">受票方集团名称</label>
                </div>
                <div class="form-value">
                    <el-form-item label="" prop="receiverRealComCode">
                        <el-input class="width-1-5x" v-model="invoiceVoucher.receiverRealName" :disabled="true"></el-input>
                        <span class="swb-btn swb-btn-link" v-if="settleProofId == null" @click="setRealCom">选择实体公司</span>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">受票方公司编码</label>
                </div>
                <div class="form-value">
                    <el-form-item label="" prop="receiverRealComCode">
                        <el-input class="width-1-5x" v-model="invoiceVoucher.receiverRealComCode" :disabled="true"></el-input>
                        <span class="swb-btn swb-btn-link" v-if="settleProofId == null" @click="setRealCom">选择实体公司</span>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">主体类型</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-form-item prop="invoiceSubjectType">
                        <el-select v-model="invoiceVoucher.invoiceSubjectType" :disabled="true">
                            <el-option v-for="item in invoiceSubjectTypeList" :label="item.text" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">主体信息</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{ invoiceTypeMaps[invoiceVoucher.invoiceType] || '' }}</span>
                </div>
            </div>
        </div>
        <div class="simple-form flex col-2">
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">发票抬头</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-form-item prop="invoiceTitle">
                        <span>{{ invoiceVoucher.invoiceTitle || '无' }}</span>
                        <a class="swb-bth swb-btn-link" @click="selectInvoiceInfo">选择</a>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">受票方纳税识别号</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{ invoiceVoucher.receiverTaxPayerNo || '无' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">税率</label>
                </div>
                <div class="form-value ">
                    <el-form-item prop="taxRate">
                        <el-select v-if="normalFlag" class="width-1-5x" v-model="invoiceVoucher.taxRate" placeholder="请选择税率" clearable @change="changeActualAmount(true)">
                            <el-option v-for="item in fiscalTaxMarkList" :key="item.rate" :label="item.rate" :value="item.rate"></el-option>
                        </el-select>
                        <el-input class="width-1-5x" v-else v-model="invoiceVoucher.taxRate" @blur="changeActualAmount(true)"></el-input>
                        <span>%</span>
                    </el-form-item>
                </div>
            </div>
        </div>

        <div class="simple-form flex col-2">
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">实际价税合计</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="actualAmount">
                        <el-input type="number" class="width-1-5x" @change="changeActualAmount(false)" v-model="invoiceVoucher.actualAmount"></el-input>
                        <span>元</span>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>价税合计</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{ (parseFloat(invoiceVoucher.amount || 0)).toFixed(2) }}</span>
                    <span>元</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">实际合计金额</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="actualNtxAmount">
                        <el-input type="number" class="width-1-5x" @change="changeActualNtxAmount()" v-model="invoiceVoucher.actualNtxAmount"></el-input>
                        <span>元</span>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>合计金额</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="amount">
                        <!--@change="changeNtxAmount()"-->
                        <el-input type="number" class="width-1-5x" v-model="invoiceVoucher.ntxAmount"></el-input>
                        <span>元</span>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">实际合计税额</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="actualTaxAmount">
                        <el-input type="number" class="width-1-5x" @change="changeActualTaxAmount()" v-model="invoiceVoucher.actualTaxAmount"></el-input>
                        <span>元</span>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>合计税额</label>
                </div>
                <div class="form-value width-1-5x">
                    <span>{{ (parseFloat(invoiceVoucher.taxAmount || 0)).toFixed(2) }}</span>
                    <span>元</span>
                </div>
            </div>
        </div>
        <div class="simple-form flex col-2">
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">发票号</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-form-item prop="actualNo">
                        <el-input v-model="invoiceVoucher.actualNo"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>发票代码</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-form-item prop="actualCode">
                        <el-input v-model="invoiceVoucher.actualCode"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>实际开票日期</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="actualDate">
                        <el-date-picker class="width-1-5x" v-model="invoiceVoucher.actualDate" type="date" placeholder="实际开票日期"></el-date-picker>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>发票方式</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-radio-group v-model="invoiceVoucher.issueMethod">
                        <el-radio :label="0">纸质发票</el-radio>
                        <el-radio :label="1">电子发票</el-radio>
                        <el-radio :label="2">全电发票</el-radio>
                    </el-radio-group>
                </div>
            </div>

            <div class="form-group center">
                <div class="form-label">
                    <label>受票方联系电话</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-form-item prop="buyerLinkTel">
                        <el-input v-model="invoiceVoucher.receiverContactTel"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>受票方联系地址电话</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-form-item prop="receiverAddrTel">
                        <el-input placeholder="请输入地址 电话信息" v-model="invoiceVoucher.receiverAddrTel"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>受票方银行名称</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-form-item prop="buyerBankName">
                        <el-input v-model="invoiceVoucher.receiverBankName"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>受票方银行账号</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-form-item prop="buyerAcctNo">
                        <el-input v-model="invoiceVoucher.receiverAcctNo"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>受票方联系人姓名</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-form-item prop="buyerContactName">
                        <el-input v-model="invoiceVoucher.receiverContactName"></el-input>
                    </el-form-item>
                </div>
            </div>
        </div>
        <div class="content-caption dashed">
            <span>附件信息</span>
        </div>
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label>附件信息</label>
                </div>
                <div class="form-value">
                    <swb-file-upload fileGroup="image-goods" :onBeforeUpload="onBeforeUpload" :onProgress="onProgress" :onDone="onUploadDone" :multipleFile="false"></swb-file-upload>
                    <div class="file-area clearfix" v-if="invoiceVoucher.fileUuid != null && invoiceVoucher.fileUuid != ''">
                        <swb-file-item :fileName="invoiceVoucher.fileExtName" :fileUuid="invoiceVoucher.fileUuid" :fileBrowseUrl="invoiceVoucher.fileBrowseUrl" :fileDownloadUrl="invoiceVoucher.fileBrowseUrl" :deletable="true"
                                       :onDelete="removeUpload"></swb-file-item>
                    </div>
                </div>
            </div>
        </div>
    </el-form>
</template>

<script>
    import {Utils} from '../../app.base'
    import {MsgBox} from '../../app.vues'
    import {selectRealComDlg} from '../comn/dialog'
    import {selectInvoiceSubjectDlg} from './selectDlg'
    import {getMerchantBizParam} from '../asset/assetMain'

    import userApi from '../../api/user'
    import merchtComnApi from '../../api/merchtComn'
    import finacApi from '../../api/merchtFinac'
    import fiscalBizApi from '../../api/fiscalBiz'
    import settleApi from '../../api/settle'

    export default {
        name: 'swb-invoice-voucher-save',
        desc: '登记发票',
        props: {
            settleProofId: {
                type: Number,
                default: null
            },
            invoiceAmount: {
                type: Number,
                default: null
            },
            invoiceType: {
                type: Number,
                default: null
            }
        },
        data: function () {
            let checkNull = function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('不可为空'));
                } else {
                    callback();
                }
            };
            let checkActualNo = function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('不可为空'));
                } else {
                    if (value.length > 30) {
                        callback(new Error('长度不可超过30个字符'));
                    } else {
                        callback();
                    }
                }
            };
            let checkActualCode = function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback();  // new Error('不可为空') 可为空，但要控制长度
                } else {
                    if (value.length > 15) {
                        callback(new Error('长度不可超过15个字符'));
                    } else {
                        callback();
                    }
                }
            };
            return {
                invoiceVoucher: {
                    invoiceTitle: null,
                    invoiceSubjectType: 1,  // 发票主体类型：公司（固定）
                    issueMethod: 0,
                    amount: 0.00,
                    actualAmount: 0.00,
                    taxRate: null,
                    electFlag: false,
                    actualDate: new Date()
                },
                invoiceSubjectTypeList: getEnumList('invoiceSubjectType'),
                invoiceTypeMaps: getEnumMap('invoiceType', 'value2text'),
                invoiceIssueMethodMap: getEnumMap('invoiceIssueMethod', 'value2text'),
                //
                fiscalTaxMarkList: [],
                rules: {
                    receiverRealComCode: [{validator: checkNull, trigger: 'blur'}],
                    invoiceSubjectType: [{validator: checkNull, trigger: 'blur'}],
                    amount: [{validator: checkNull, trigger: 'blur'}],
                    actualAmount: [{validator: checkNull, trigger: 'blur'}],
                    invoiceTitle: [{validator: checkNull, trigger: 'blur'}],
                    actualTaxAmount: [{validator: checkNull, trigger: 'blur'}],
                    actualNtxAmount: [{validator: checkNull, trigger: 'blur'}],
                    actualNo: [{validator: checkActualNo, trigger: 'blur'}],
                    actualCode: [{validator: checkActualCode, trigger: 'blur'}]
                },
                normalFlag: null
            }
        },
        created: function () {
            let self = this;
            if (!Utils.isNoB(this.settleProofId)) {
                let msgBoxDlg = MsgBox.loading();
                settleApi.getSettleProof(self.settleProofId, function (result) {
                    msgBoxDlg.close();
                    if (result.type == 'info') {
                        let settleProof = result.data || {};
                        //
                        let invoiceVoucher = self.invoiceVoucher || {};
                        invoiceVoucher.receiverRealId = settleProof.buyerRealId;
                        invoiceVoucher.receiverRealName = settleProof.buyerRealName;
                        invoiceVoucher.receiverRealComId = settleProof.buyerRealComId;
                        invoiceVoucher.receiverRealComCode = settleProof.buyerRealComCode;
                        invoiceVoucher.receiverRealComName = settleProof.buyerRealComName;
                        invoiceVoucher.invoiceType = settleProof.invoiceType;
                        invoiceVoucher.issuerAdoptedComId = settleProof.sellerAdoptedComId;
                        invoiceVoucher.issuerRealId = settleProof.sellerRealId;
                        invoiceVoucher.issuerRealName = settleProof.sellerRealName;
                        invoiceVoucher.issuerRealComId = settleProof.sellerRealComId;
                        invoiceVoucher.issuerRealComName = settleProof.sellerRealComName;
                        invoiceVoucher.issuerOlCollabo = settleProof.sellerOlCollabo; // 开票方不协同
                        //
                        self.invoiceVoucher = Utils.merge({}, invoiceVoucher);
                        //
                        self.getInvoiceSubject(invoiceVoucher.receiverRealComId);
                        self.getFiscalTaxMarkList(settleProof.bizType);
                        //
                        getMerchantBizParam('asset.finac.enabled', function (result) {
                            self.normalFlag = Utils.isTrue(result);
                        }, 2, null, invoiceVoucher.receiverRealComId);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            }
            // 未结算金额
            let invoiceAmount = self.invoiceAmount || null;
            if (!Utils.isNoB(invoiceAmount)) {
                let invoiceVoucher = self.invoiceVoucher || {};
                invoiceVoucher.actualAmount = parseFloat(invoiceAmount).round(2);
                invoiceVoucher.amount = parseFloat(invoiceAmount).round(2);
                self.invoiceVoucher = Utils.merge({}, invoiceVoucher);
            }
            this.getCurrentUserInfo();
            if (Utils.isNoB(this.settleProofId)) {
                this.getFiscalTaxMarkList();
            }
        },
        methods: {
            getCurrentUserInfo: function () {
                let self = this;
                userApi.getUserInfoByContext({}, function (result, jqXhr) {
                    if (result.type == 'info') {
                        let data = result.data;
                        let scopeEntity = data.scopeEntity;
                        // 已结算单的实体公司为主
                        if (Utils.isNoB(self.settleProofId)) {
                            self.getRealComInfo(scopeEntity.realComId);
                        }
                    } else {
                        self.$message.warning(result.message);
                    }
                });
            },
            getRealComInfo(id) {
                let self = this;
                let postData = {};
                postData.id = id;
                merchtComnApi.getRealCom(postData, function (result) {
                    if (result.type == 'info') {
                        let realComInfo = result.data || {};
                        let invoiceVoucher = self.invoiceVoucher || {};
                        invoiceVoucher.receiverRealComId = realComInfo.id;
                        invoiceVoucher.receiverRealComCode = realComInfo.code;
                        invoiceVoucher.receiverRealComName = realComInfo.name;
                        self.invoiceVoucher = Utils.merge({}, invoiceVoucher);
                        //
                        getMerchantBizParam('asset.finac.enabled', function (result) {
                            self.normalFlag = Utils.isTrue(result);
                        }, 2, null, invoiceVoucher.receiverRealComId);
                        //
                        self.getInvoiceSubject(realComInfo.id, null);
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            getInvoiceSubject: function (buyerRealComId, buyerRealComCode) {
                let self = this;
                let params = {};
                if (Utils.isNoB(buyerRealComId)) {
                    params.realComCodeFlag = true;
                    params.realComCode = buyerRealComCode;
                } else {
                    params.realComId = buyerRealComId;
                }
                params.disabled = false;
                if (!Utils.isNoB(self.invoiceType)) {
                    params.invoiceType = self.invoiceType;
                }
                finacApi.getMerchantInvoiceSubjectList(params, function (result) {
                    if (result.type === 'info') {
                        let invoiceSubjectList = Utils.merge([], result.data);
                        let invoiceSubjectInfo = null;
                        if (!Utils.isNoB(self.invoiceType)) {
                            for (let i = 0; i < invoiceSubjectList.length; i++) {
                                if (Utils.isTrue(invoiceSubjectList[i].defaulted)) {    // 获取默认的
                                    invoiceSubjectInfo = invoiceSubjectList[i];
                                    break;
                                }
                            }
                        } else {
                            // 无发票类型时，获取任意一个作为默认
                            invoiceSubjectInfo = invoiceSubjectList[0];
                        }
                        if (!Utils.isNoB(invoiceSubjectInfo)) {
                            let invoiceVoucher = self.invoiceVoucher || {};
                            invoiceVoucher.invoiceType = invoiceSubjectInfo.invoiceType || null;
                            invoiceVoucher.invoiceTitle = invoiceSubjectInfo.invoiceTitle || null;
                            invoiceVoucher.receiverTaxPayerNo = invoiceSubjectInfo.taxPayerNo || null;
                            invoiceVoucher.receiverContactTel = invoiceSubjectInfo.contactTel || null;
                            invoiceVoucher.receiverAddrTel = invoiceSubjectInfo.linkAddr || null;
                            invoiceVoucher.receiverBankName = invoiceSubjectInfo.bankName || null;
                            invoiceVoucher.receiverAcctNo = invoiceSubjectInfo.acctNo || null;
                            //
                            self.invoiceVoucher = Utils.merge({}, invoiceVoucher);
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            setRealCom() {
                let self = this;
                let invoiceVoucher = this.invoiceVoucher || {};
                let bizUnitId = self.bizUnitId;
                selectRealComDlg({bizUnitId: bizUnitId}, function (realCom, theDlg) {
                    theDlg.close();
                    invoiceVoucher.receiverRealComId = realCom.id;
                    invoiceVoucher.receiverRealComCode = realCom.code;
                    invoiceVoucher.receiverRealComName = realCom.name;
                    self.invoiceVoucher = Utils.merge({}, invoiceVoucher);
                    // 自动获取发票信息
                    self.getInvoiceSubject(realCom.id);
                    //
                    self.clearSubjectInfo();
                });
            },
            getFiscalTaxMarkList: function (settleProofBizType) {
                let self = this;
                let postData = {};
                postData.disabled = false;
                postData.type = getEnumInfoWith('taxType', 'name', 'JXS').value;
                if (!Utils.isNoB(settleProofBizType)) {
                    if (settleProofBizType == 1) {
                        // 商品买卖
                        postData.sysBizLineId = 1;   // 资产税码
                    } else {
                        // 工单服务
                        postData.sysBizLineId = 2;  // 服务税码
                    }
                }
                //
                let theLoad = MsgBox.loading();
                fiscalBizApi.getFiscalTaxMarkPageList(postData, function (result) {
                    theLoad.hide();
                    if (result.type === 'info') {
                        let fiscalTaxMarkList = result.data || [];
                        if (fiscalTaxMarkList.length > 0) {
                            fiscalTaxMarkList.forEach(function (item) {
                                item.rate = parseFloat(item.rate).toFixed(2)
                            })
                        }
                        //
                        let invoiceVoucher = self.invoiceVoucher || {};
                        invoiceVoucher.taxRate = fiscalTaxMarkList[0].rate;
                        self.invoiceVoucher = Utils.merge({}, invoiceVoucher);
                        // 根据税率重算其他金额
                        self.changeActualAmount(true);
                        //
                        self.fiscalTaxMarkList = fiscalTaxMarkList;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 选择发票主题
            selectInvoiceInfo: function () {
                let self = this;
                let params = {
                    buyerRealComId: self.invoiceVoucher.receiverRealComId,
                    buyerRealComCode: self.invoiceVoucher.receiverRealComCode,
                    invoiceType: self.invoiceType
                };
                selectInvoiceSubjectDlg(params, function (resultData, theDlag) {
                    theDlag.close();
                    let invoiceVoucher = self.invoiceVoucher || {};
                    invoiceVoucher.invoiceType = resultData.invoiceType || null;
                    invoiceVoucher.invoiceTitle = resultData.invoiceTitle || null;
                    invoiceVoucher.receiverTaxPayerNo = resultData.taxPayerNo || null;
                    invoiceVoucher.receiverContactName = resultData.contactName || null;
                    invoiceVoucher.receiverContactTel = resultData.contactTel || null;
                    invoiceVoucher.receiverAddrTel = resultData.linkAddr || null;
                    invoiceVoucher.receiverBankName = resultData.bankName || null;
                    invoiceVoucher.receiverAcctNo = resultData.acctNo || null;
                    //
                    self.invoiceVoucher = Utils.merge({}, invoiceVoucher);
                })
            },
            clearSubjectInfo: function () {
                let invoiceVoucher = this.invoiceVoucher || {};
                invoiceVoucher.invoiceType = null;
                invoiceVoucher.invoiceTitle = null;
                invoiceVoucher.receiverTaxPayerNo = null;
                invoiceVoucher.receiverContactTel = null;
                invoiceVoucher.receiverBankName = null;
                invoiceVoucher.receiverAcctNo = null;
                this.invoiceVoucher = Utils.merge({}, invoiceVoucher);
            },
            changeNtxAmount: function () {
                let invoiceVoucher = this.invoiceVoucher || {};
                // invoiceVoucher.ntxAmount = (parseFloat(invoiceVoucher.amount) / (1 + (parseFloat(invoiceVoucher.taxRate) * 0.01))).toFixed(2);
                //
                if (Utils.isNoB(invoiceVoucher.ntxAmount)) {
                    invoiceVoucher.amount = parseFloat(0).toFixed(2);
                    invoiceVoucher.taxAmount = parseFloat(0).toFixed(2);
                    invoiceVoucher.actualAmount = parseFloat(0).toFixed(2);
                    invoiceVoucher.actualNtxAmount = parseFloat(0).toFixed(2);
                    invoiceVoucher.actualTaxAmount = parseFloat(0).toFixed(2);
                } else {
                    invoiceVoucher.amount = (parseFloat(invoiceVoucher.ntxAmount) * (1 + (parseFloat(invoiceVoucher.taxRate) * 0.01))).toFixed(2);
                    invoiceVoucher.taxAmount = (parseFloat(invoiceVoucher.amount) - parseFloat(invoiceVoucher.ntxAmount)).toFixed(2);
                    //
                    // if(Utils.isNoB(invoiceVoucher.actualAmount) || invoiceVoucher.actualAmount == 0.00) {
                    invoiceVoucher.actualAmount = parseFloat(invoiceVoucher.amount).toFixed(2);
                    //
                    invoiceVoucher.actualNtxAmount = (parseFloat(invoiceVoucher.actualAmount) / (1 + (parseFloat(invoiceVoucher.taxRate) * 0.01))).toFixed(2);
                    invoiceVoucher.actualTaxAmount = (invoiceVoucher.actualAmount - invoiceVoucher.actualNtxAmount).toFixed(2) || 0.00;
                    // }
                    if (!Utils.isNoB(invoiceVoucher.amount)) {
                        invoiceVoucher.amount = parseFloat(invoiceVoucher.amount).toFixed(2);
                    }
                }
                this.invoiceVoucher = Utils.merge({}, invoiceVoucher);
            },
            // 实际合计金额
            changeActualNtxAmount: function () {
                let invoiceVoucher = this.invoiceVoucher || {};
                //
                invoiceVoucher.actualAmount = (parseFloat(invoiceVoucher.actualNtxAmount) * (1 + (parseFloat(invoiceVoucher.taxRate) * 0.01))).toFixed(2);
                invoiceVoucher.actualTaxAmount = (parseFloat(invoiceVoucher.actualAmount) - parseFloat(invoiceVoucher.actualNtxAmount)).toFixed(2);
                //
                this.invoiceVoucher = Utils.merge({}, invoiceVoucher);
            },
            // 税率-实际金额change事件
            changeActualAmount: function (taxRateChangeFlag) {
                let invoiceVoucher = this.invoiceVoucher || {};
                //
                if (Utils.isNoB(invoiceVoucher.taxRate)) {
                    invoiceVoucher.taxRate = 0;
                }
                if (!Utils.isNoB(invoiceVoucher.ntxAmount) && Utils.isTrue(taxRateChangeFlag)) {
                    invoiceVoucher.amount = (parseFloat(invoiceVoucher.ntxAmount) * (1 + (parseFloat(invoiceVoucher.taxRate) * 0.01))).toFixed(2);
                    invoiceVoucher.taxAmount = (parseFloat(invoiceVoucher.amount) - parseFloat(invoiceVoucher.ntxAmount)).toFixed(2);
                    invoiceVoucher.actualAmount = parseFloat(invoiceVoucher.amount).toFixed(2);
                }
                //
                if (!Utils.isNoB(invoiceVoucher.actualAmount) && !Utils.isNoB(invoiceVoucher.taxRate)) {
                    invoiceVoucher.actualAmount = parseFloat(invoiceVoucher.actualAmount).round(2);
                    invoiceVoucher.actualNtxAmount = (parseFloat(invoiceVoucher.actualAmount) / (1 + (parseFloat(invoiceVoucher.taxRate) * 0.01))).toFixed(2);
                    invoiceVoucher.actualTaxAmount = (invoiceVoucher.actualAmount - invoiceVoucher.actualNtxAmount).toFixed(2) || 0.00;
                }
                //
                this.invoiceVoucher = Utils.merge({}, invoiceVoucher);
            },
            changeActualTaxAmount: function () {
                let invoiceVoucher = this.invoiceVoucher || {};
                if (!Utils.isNoB(invoiceVoucher.actualTaxAmount)) {
                    invoiceVoucher.actualTaxAmount = parseFloat(invoiceVoucher.actualTaxAmount).toFixed(2);
                }
                // 税额发生变化不计算-税率
                invoiceVoucher.actualAmount = (parseFloat(invoiceVoucher.actualTaxAmount) + parseFloat(invoiceVoucher.actualNtxAmount)).toFixed(2);
                //
                this.invoiceVoucher = Utils.merge({}, invoiceVoucher);
            },
            //
            //上传前（进行验证检查）处理，可以返回false取消上传
            onBeforeUpload: function (fileItems, uploader) {
                if (fileItems.length === 0) {
                    this.$message.error('喂，你还没选择要上传的文件吧');
                    return false;
                }
            },
            //上传进度处理
            onProgress: function (progress) {
                let self = this;
                self.percentage = Math.floor((progress.loaded / progress.total) * 100);
            },
            //上传完毕处理（根据result.type判断是否有误）
            onUploadDone: function (result) {
                let self = this;
                if (result.type === 'info') {
                    let invoiceVoucher = this.invoiceVoucher || {};
                    //
                    let file = result.data.files[0];
                    invoiceVoucher.fileUuid = file.fileUuid;
                    invoiceVoucher.fileExtName = file.fileExtName;
                    invoiceVoucher.fileBrowseUrl = file.fileBrowseUrl;
                    this.invoiceVoucher = Utils.merge({}, invoiceVoucher);
                } else {
                    MsgBox.failure(result.message);
                }
            },
            removeUpload: function () {
                let invoiceVoucher = this.invoiceVoucher || {};
                invoiceVoucher.fileUuid = '';
                invoiceVoucher.fileExtName = '';
                invoiceVoucher.fileBrowseUrl = '';
                this.invoiceVoucher = Utils.merge({}, invoiceVoucher);
            },
            //
            getDlgResult: function () {
                let self = this;
                let result = {
                    type: 'warn'
                };
                this.$refs['ruleForm'].validate(function (valid) {
                    if (valid) {
                        result.type = 'info';
                        let invoiceVoucher = self.invoiceVoucher;
                        if (!Utils.isNoB(invoiceVoucher.actualDate)) {
                            invoiceVoucher.actualDate = invoiceVoucher.actualDate.format('yyyy-MM-dd');
                        }
                        result.data = Utils.merge({}, invoiceVoucher);
                    } else {
                        result.message = '请输入必填项';
                    }
                });
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/invoiceVoucher/InvoiceVoucherSave.vue